import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'month'
})
export class MonthPipe implements PipeTransform {
	transform(value: any, zeroIndex: boolean) {
		if (value) {
			const months = ['January', 'February', 'March', 'April', 'May', 'June',
				'July', 'August', 'September', 'October', 'November', 'December'];
			let val = value;
			if (!zeroIndex) {
				val = parseInt(value, 10) - 1;
			}
			return months[val];
		}
	}
}
